import { createSelector } from 'reselect';

export const getOrderedAreas = createSelector(
  (state) => state.areas.get('areaList'),
  (state) => state.app.get('selectedLanguage'),
  (areas, selectedLanguage) => {
    if (areas) {
      return areas.sort((a, b) => a.get('name').get(selectedLanguage).localeCompare(b.get('name').get(selectedLanguage), selectedLanguage, { sensitivity: 'base' }));
    }
    return null;
  },
);

export const getSelectedAreaId = (state) => state.areas.get('selectedAreaId');

export const getSelectedAoi = createSelector(
  (state) => state.areas.get('areas'),
  (state) => state.areas.get('selectedAreaId'),
  (areas, selectedAreaId) => areas.get(selectedAreaId),
);

export const isAreasLoading = (state) => state.areas.get('loading');
